export default __webpack_public_path__ + "static/media/ic-percentage.f2680f16.svg";